import { Component, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';
import 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ActivatedRoute } from '@angular/router';
import { ConsumedProductsService } from 'src/app/home/services/consumed-products.service';

@Component({
  selector: 'app-consumed-products',
  templateUrl: './consumed-products.component.html',
  styleUrl: './consumed-products.component.scss'
})
export class ConsumedProductsComponent implements OnInit{

  public chartData: any; 
  public stockId: string = ""; 
  public warningMessage: string = "";

  constructor(private route: ActivatedRoute,private consumedProductsService: ConsumedProductsService) { }

  ngOnInit(): void { 
    this.route.queryParams.subscribe(params => {
      const storeIdFromParams = params['id'];
      if (storeIdFromParams) {
        this.stockId = storeIdFromParams;
        this.createDonutChart(this.stockId);
      } else {
        console.error('No stock ID provided in query parameters');
      }
    });
  }

  createDonutChart(storeId: string): void {
    this.consumedProductsService.getChartData(storeId).subscribe({
      next: (res) => {
        this.chartData = res.data
        this.generateChart()
      },
      error: (e) => console.error(e),
      complete: () => console.info('complete') 
  }
       
    );
  }


  generateChart(): void { 
    const container = document.getElementById('chartContainer');
    const chartData = this.chartData;
   
    // if (chartData.datasets.length === 0 || chartData.labels.length === 0) {
    //   // If no data is available, display the message 
    //   container.innerHTML = '<div style="color: #A3A3A3; font-size: 16px; padding-left: 5px; d-flex align-items-center justify-content-center">No stock consumed at this moment to view</div>';
    //   return;
    // }
    if (!chartData || chartData.datasets.length === 0 || chartData.labels.length === 0) {
      this.warningMessage = "No stock available at this moment to view";
      return;
    }

    this.warningMessage = "";

    const ctx = document.getElementById('donutChart') as HTMLCanvasElement;

    const total = chartData.datasets.reduce((acc: number, dataset: any) => acc + dataset.data.reduce((subAcc: number, value: number) => subAcc + value, 0), 0);
  
    const chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: chartData.labels,
        datasets: chartData.datasets.map(dataset => ({
          label: dataset.label,
          data: dataset.data,
          backgroundColor: ['#35B5D4', '#24B946', '#FFCB46', '#43C6AE', '#FF872F'],
          hoverOffset: 4
        }))   
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          },
          datalabels: {
            color: '#000000',
            formatter: (value: number, context: any) => {
              const percentage = (value / total) * 100;
              return `${Math.round(percentage)}%`;
            },
            anchor: 'end',
            align: 'start',
            offset: 0,
            font: {
              size: 16
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      plugins: [ChartDataLabels],
    });
  
    // Create legend
    const legendContainer = document.getElementById('legend');
    if (legendContainer) {
      legendContainer.innerHTML = ''; // Clear existing content
      chart.data.labels.forEach((label: string, index: number) => {
        const backgroundColor = chart.data.datasets[0].backgroundColor[index];
        const legendItem = document.createElement('div');
        legendItem.innerHTML = `
          <div class="legend-item" style="display: flex;margin-bottom:5px">
           <div class="bg-legend"><div class="legend-color" style="background-color: ${backgroundColor}; width: 20px; height: 20px; border-radius: 50%;margin-right: 5px"></div></div>
           <div class="label-conetnt"><span class="legend-label" style="font-size: 15px">${label}: ${chart.data.datasets[0].data[index]}</span></div>
            
          </div>
        `;
        legendContainer.appendChild(legendItem);
      });
      legendContainer.style.flex = ''; // Remove width
    }
  }

  
  
  
  

}
